export function normalizeBrokerOptions(brokerTuples) {
  return brokerTuples.map(broker => ({ label: broker[0], value: broker[1] }));
}
